<script context="module">
	import { z } from "zod";
	export const name = "Clasament (1–5)";
	export const CustomFields = z.object({
		title: z.string().optional(),
	});
</script>

<script>
	// "Cele mai citite": numbered compact rows, accent serif counters
	import ContentItem from "@reperio-news/core.components/blocks/ContentItem/View.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	const rowFields = { show_kicker: false, show_date: false, compact: true };

	$: items = (data && data.content && data.content.items) || [];
	$: title = (data && data.custom_fields && data.custom_fields.title) || "";
</script>

<section class="af-ranked">
	{#if title}<h2 class="af-heading af-ranked__heading">{title}</h2>{/if}
	<ol class="af-ranked__list">
		{#each items as item, index (item.id || index)}
			<li class="af-ranked__item">
				<ContentItem data={{ content: item, layout: "row", custom_fields: rowFields }} indexInContainer={[index, items.length]} />
			</li>
		{/each}
	</ol>
</section>

<style lang="scss">
	/* "Cele mai citite": a surface card (elevation), compact numbered rows */
	.af-ranked {
		width: 100%;
		height: 100%;
		grid-column: 1 / -1;
		padding: var(--af-space-4);
		background: var(--af-surface);
		border-radius: var(--af-radius-card);
		box-shadow: var(--af-shadow-card);
	}

	.af-ranked__heading {
		margin-bottom: var(--af-space-2);
	}

	.af-ranked__list {
		list-style: none;
		margin: 0;
		padding: 0;
		counter-reset: af-rank;
	}

	.af-ranked__item {
		display: grid;
		grid-template-columns: 1.5rem minmax(0, 1fr);
		column-gap: var(--af-space-2);
		align-items: start;
		counter-increment: af-rank;

		&::before {
			content: counter(af-rank);
			padding-top: var(--af-space-3);
			font: 600 1.125rem / 1 var(--af-font-serif);
			color: var(--af-accent);
		}
	}

	@media (min-width: 768px) {
		.af-ranked {
			padding: var(--af-space-6);
		}
	}

	.af-ranked__item:not(:last-child) :global(.af-row) {
		border-bottom: 1px solid var(--af-hairline);
	}
</style>
